import React, { FC } from 'react';
import { Box, Container, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/OffRoadToursPromoSection/OffRoadToursPromoSection.styles';

const OffRoadToursPromoSectionSkeleton: FC = () => {
  return (
    <StyledBox>
      <Container maxWidth="xl">
        {/* Tour Type (overline) */}
        <Skeleton variant="text" width={150} height={20} sx={{ mb: 2 }} />
        
        {/* Tour Name */}
        <Skeleton variant="text" width={300} height={32} sx={{ mb: 5 }} />
        
        {/* Gallery Grid Skeleton */}
        <Box sx={{ mb: 4 }}>
          <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 2 }} />
        </Box>
        
        {/* Title (overline) */}
        <Skeleton variant="text" width={200} height={20} sx={{ mt: 4, mb: 2 }} />
        
        {/* Subtitle */}
        <Skeleton variant="text" width={350} height={32} sx={{ mb: 2 }} />
        
        {/* Description - Multiple lines */}
        <Box className="OTPSDesc" sx={{ mb: 1 }}>
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="95%" height={20} />
          <Skeleton variant="text" width="70%" height={20} />
        </Box>
        
        {/* Learn More Button */}
        <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: 1, mt: 2 }} />
      </Container>
    </StyledBox>
  );
};

export { OffRoadToursPromoSectionSkeleton };